import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { PageHeader, EmptyState } from "@/components/Shared";
import api from "@/lib/api";
import { TL, formatDate, TXN_KIND_LABEL, ACCOUNT_TYPE_LABEL } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function HareketlerPage() {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({ start: "", end: "", kind: "all" });
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    const params = {};
    if (filters.start) params.start = filters.start;
    if (filters.end) params.end = filters.end;
    if (filters.kind && filters.kind !== "all") params.kind = filters.kind;
    const { data } = await api.get("/hareketler", { params });
    setItems(data);
    setLoading(false);
  };
  useEffect(() => { load().catch(console.error); }, []);

  return (
    <Layout>
      <PageHeader title="Tüm Hareketler" subtitle="Kasa ve banka hesaplarındaki tüm işlemler" testId="hareketler-header" />

      <div className="border border-border rounded-md bg-background p-4 mb-6" data-testid="hareketler-filters">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-wider text-foreground/60">Başlangıç</Label>
            <Input type="date" value={filters.start} onChange={(e) => setFilters({ ...filters, start: e.target.value })} data-testid="filter-start" />
          </div>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-wider text-foreground/60">Bitiş</Label>
            <Input type="date" value={filters.end} onChange={(e) => setFilters({ ...filters, end: e.target.value })} data-testid="filter-end" />
          </div>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-wider text-foreground/60">İşlem Türü</Label>
            <Select value={filters.kind} onValueChange={(v) => setFilters({ ...filters, kind: v })}>
              <SelectTrigger data-testid="filter-kind"><SelectValue placeholder="Tümü" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tümü</SelectItem>
                <SelectItem value="gelir">Gelir</SelectItem>
                <SelectItem value="gider">Gider</SelectItem>
                <SelectItem value="tahsilat">Tahsilat</SelectItem>
                <SelectItem value="odeme">Ödeme</SelectItem>
                <SelectItem value="transfer_in">Transfer Giriş</SelectItem>
                <SelectItem value="transfer_out">Transfer Çıkış</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button onClick={load} disabled={loading} className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="apply-filters">
            {loading ? "Yükleniyor..." : "Uygula"}
          </Button>
        </div>
      </div>

      <div className="border border-border rounded-md bg-background overflow-hidden" data-testid="hareketler-table">
        {items.length === 0 ? (
          <EmptyState title="Hareket bulunamadı" hint="Filtreleri değiştirin veya hesaplarınıza hareket ekleyin." testId="hareketler-empty" />
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-secondary/50 text-foreground/70">
              <tr>
                <th className="text-left py-3 px-4 text-[11px] uppercase tracking-wider">Tarih</th>
                <th className="text-left py-3 px-4 text-[11px] uppercase tracking-wider">Hesap</th>
                <th className="text-left py-3 px-4 text-[11px] uppercase tracking-wider">Tür</th>
                <th className="text-left py-3 px-4 text-[11px] uppercase tracking-wider">Cari</th>
                <th className="text-left py-3 px-4 text-[11px] uppercase tracking-wider">Açıklama</th>
                <th className="text-right py-3 px-4 text-[11px] uppercase tracking-wider">Tutar</th>
              </tr>
            </thead>
            <tbody>
              {items.map((t) => {
                const isIn = ["gelir", "tahsilat", "transfer_in"].includes(t.kind);
                return (
                  <tr key={t.id} className="border-t border-border hover:bg-secondary/20 transition-colors">
                    <td className="py-3 px-4 text-foreground/80">{formatDate(t.date)}</td>
                    <td className="py-3 px-4">
                      <Link to={`/hesaplar/${t.account_id}`} className="text-primary hover:underline">{t.account_name}</Link>
                      <span className="text-xs text-foreground/50 ml-1">({ACCOUNT_TYPE_LABEL[t.account_type]})</span>
                    </td>
                    <td className="py-3 px-4">
                      <span className="bg-secondary text-secondary-foreground px-2 py-0.5 rounded-sm text-xs border border-border">
                        {TXN_KIND_LABEL[t.kind] || t.kind}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-foreground/70">
                      {t.cari_id ? <Link className="text-primary hover:underline" to={`/cariler/${t.cari_id}`}>{t.cari_name || "—"}</Link> : "—"}
                    </td>
                    <td className="py-3 px-4 text-foreground/80">{t.description || "—"}</td>
                    <td className={`py-3 px-4 text-right tabular-nums font-medium ${isIn ? "text-[hsl(var(--success))]" : "text-destructive"}`}>
                      {isIn ? "+" : "−"} {TL(t.amount)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </Layout>
  );
}
